
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col> 
          <a-col :md="6" :sm="24">
            <a-form-item label="省市">
              <a-cascader :options="areaOptions" allowClear placeholder="请选择" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item> 
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>
  
          <a-col :md="6" :sm="24">
            <a-form-item label="支付时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>
 
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button @click="download" style="margin-left: 8px" >
        单位财务汇总表下载 <a-icon type="download" />
      </a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <img style="width: 38px ; height: 38px; float: left" :src="record.pic_url" v-if="false" />
          <div style="margin-left: 10px; float: left">
            {{record.name}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            负责人:{{record.nickname}} <span style="color: #999">手机:{{record.phone}}</span>
          </div>
      </span>
      <span slot="code" slot-scope="text,record">
        应收 ￥102283.02  
        <br />
        已收 ￥102283.02 
        <br />
        未收 ￥102283.02 
        <br />
        应退款 ￥912.87
        <br />
        未退款 ￥512.00
        <br /> 
      </span> 
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleMingxi(record)">明细</a>
          <a-divider type="vertical" />    
          <a @click="logDownload(record)">下载明细表</a>   

        </template>
      </span>
    </s-table>
 
    <a-modal
      :maskClosable="false"
      title="查看明细"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="mingxiVisible"
      @ok="mingxiVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
          :columns="mingxiColumns"
          :dataSource="mingxiList"
          :pagination="false"
          rowKey="id"
          :scroll="{ y: 300 }"
          bordered
        >  
        </a-table>
      </a-spin>
    </a-modal>
   



  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import UserPicker from '@/components/UserPicker/'
  import setting from '@/config/setting'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  import qs from 'qs'
  moment.locale('zh-cn');

  import { getDanweiList ,
  sjsqOptions,getCaiwuDanweiLogList } from '@/api/sai' 
  export default {
    name: 'DanweiList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      UserPicker,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
        userVisible: false,
        formData:{
          id:0,
          danwei:'',
          namekeys:[],
          areas:[],
          certificatepic:[],
        },
      sjsqOptions: [], 
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '汇总数据',
            dataIndex: 'code',
            scopedSlots: { customRender: 'code' },
          }, 
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getDanweiList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],   

      mingxiQuery: {
        saiqu: 0,
      },
      mingxiVisible: false,
      mingxiFormVisible: false,
      mingxiList: [],
      mingxiFormData: {
        id: 0,
        name: "",
        limit: "",
        price: "",
        show: 1,
        show_youer: 2,
        edit_admin: 2,
      },

      //表头
      mingxiColumns: [
        {
          title: "赛区",
          dataIndex: "saiqu_name", 
          width: "200px",
        },
        {
          title: "队伍",
          dataIndex: "mingcheng", 
          width: "150px",
        },
        {
          title: "支付金额",
          width: "150px",
          dataIndex: "price", 
        }, 
        {
          title: "事由",
          width: "150px",
          dataIndex: "note",
        }, 
        {
          title: "时间",
          dataIndex: "create_time_str",
          width: "150px", 
        }, 
      ],
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      this.getSjsqOptions();
    },
    methods: {
      moment,
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then(res => {
        that.sjsqOptions = res.data;
      });
    },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      }, 
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
 
    fetchMingxiList() {
      let self = this;
      getCaiwuDanweiLogList(self.mingxiQuery).then((res) => {
        self.mingxiList = res.data.list;
      });
    },

    handleMingxi(record) {
      let self = this;
      self.fetchMingxiList();
      self.mingxiQuery.saiqu = record.id;
      self.mingxiVisible = true;
    },
    

      download(){  
          window.open(setting.apiBaseURL+'/adminapi/sai/danweicaiwuhuizong?'+qs.stringify(this.queryParam)); 
      },

      logDownload(record){  
          window.open(setting.apiBaseURL+'/adminapi/sai/danweicaiwulogdownload?'+qs.stringify(this.queryParam)); 
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
 
      sjsqFilter(inputValue, path) {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
      },
    },
    filters:{
    },
    watch: {
    }
  }
</script>
